// extracted by mini-css-extract-plugin
module.exports = {"root":"TextWithIconBlock_root__ZTPDK","content":"TextWithIconBlock_content__csk7K","cardTitle":"TextWithIconBlock_cardTitle__zHPXg","iconWrap":"TextWithIconBlock_iconWrap__V2snd"};